// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import omit from 'lodash/omit';
import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';

import Divider from 'app/shared/modules/Divider';
import Linker from 'app/shared/modules/Linker';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';
import queryUtils from 'app/shared/utils/queryUtils';
import routeUtils from 'app/shared/utils/routeUtils';
import Row from 'app/shared/core/Row';
import Text from 'app/shared/core/Text';
import './style.scss';

const StyledDarkText = styled(Text)`
  color: ${colors['$hpx-grey-600']};
`;
class NearbyAreaListings extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, area } = this.props;

    /**
     * If a user reaches the end of results, this component (NearbyAreaListings) renders.
     * Therefore, we're going to make this component responsible for fetching it's
     * own nearbyArea data rather than loading nearbyArea data all the time, even in
     * context's where it's not required.
     */
    dispatch(ListingEngineActions.fetchNearbyAreasListings(area.resourceId));
  }

  renderListings = (listings) => {
    return (
      <ul className="NearbyAreaListings-unorderedList">
        {map(listings, (listing) => {
          if (listing) {
            return (
              <ListingWrapper
                key={listing.aliasEncoded}
                listing={listing}
                triggerLocation="search_results"
                triggerObject="property_card"
              />
            );
          }
        })}
      </ul>
    );
  };

  checkIfNearbyAreasEmpty = () => {
    const { nearbyAreas } = this.props;
    let allEmpty = true;
    forEach(nearbyAreas, (nearbyArea) => {
      if (nearbyArea.count > 0) {
        allEmpty = false;
      }
    });
    return allEmpty;
  };

  handleMakeNearbyUrl = (nearbyArea) => {
    const { query, filter } = this.props;
    const path = routeUtils.buildAreaPath({
      areaResourceId: nearbyArea.resourceId,
      searchSlug: filter.search.slug,
    });
    return routeUtils.buildPathWithQuery(path, omit(query, ['border', 'lat', 'lon', 'z', 'page']));
  };

  render() {
    const { area, nearbyAreas } = this.props;
    const nearbyAreasAllEmptyAfterFilter = this.checkIfNearbyAreasEmpty();

    if (nearbyAreasAllEmptyAfterFilter) {
      return null;
    }

    return (
      <div className="NearbyAreaListings">
        <Divider />
        <Row className="NearbyAreaListings-text">
          <StyledDarkText size="sm">
            If you're able to expand your search outside of <b>{area.name}</b>, check out properties in these nearby
            areas:
          </StyledDarkText>
        </Row>
        {map(nearbyAreas, (nearbyArea) => {
          if (nearbyArea.count < 1) {
            return null;
          }
          return (
            <div className="NearbyAreaListings-area" key={nearbyArea.name}>
              <Row>
                <Linker linkType="underline" to={this.handleMakeNearbyUrl(nearbyArea)}>
                  {nearbyArea.name}
                  <br />
                </Linker>
                <span>
                  <StyledDarkText size="sm">
                    {nearbyArea.count} {nearbyArea.count === 1 ? 'property' : 'properties'}
                  </StyledDarkText>
                </span>
              </Row>
              {this.renderListings(nearbyArea.listings)}
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    area: state.area.area,
    filter: state.filter,
    nearbyAreas: state.listings.nearbyAreas,
    query: queryUtils.parse(ownProps.location.search),
  };
};

export default withRouter(connect(mapStateToProps)(NearbyAreaListings));
